import { render, staticRenderFns } from "./select-currency.vue?vue&type=template&id=1d94f2e0&"
import script from "./select-currency.vue?vue&type=script&lang=js&"
export * from "./select-currency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports